
export enum AddToBasketStepState
{
    // Unset = "Unset",
    New = "New",
    Accepted = "Accepted",
    Rejecting = "Rejecting",
    Rejected = "Rejected"
}
